import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenService from '../../Common/tokenDecoder';

export default {
    getPermissionsByScreen
};

async function getPermissionsByScreen(screenCode){

    const response = await CommonGet('/api/Permission/GetPermissionsByRoleAndScreen', 'roleID=' + tokenService.getRoleFromToken() + '&screenCode='+ screenCode);
    
    return response.data;
}